export default {
  201: 'Se creó el contrato con éxito',
  202: 'Se editó el contrato con éxito',
  404: 'No se encontró el contrato.',
  408: 'Existen horarios que se solapan y empleados que no existen',
  409: 'Existen horarios que se solapan',
  410: 'Los empleados no existen',
  427: 'El código del contrato ya existe en la base de datos',
};
